import { TOKEN_STORED_KEY } from "../constants";

export const getToken = (): ReturnType<typeof localStorage.getItem> => {
  return localStorage.getItem(TOKEN_STORED_KEY);
};
